var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25369 8.27983C6.47369 7.49983 5.88569 6.6265 5.49502 5.7405C5.41302 5.55317 5.46102 5.33383 5.60569 5.18917L6.15169 4.64317C6.59902 4.19583 6.59902 3.56317 6.20836 3.1725L5.42636 2.3905C4.90569 1.86983 4.06169 1.86983 3.54102 2.3905L3.10636 2.8245C2.61236 3.3185 2.40636 4.03117 2.53969 4.73783C2.86902 6.47983 3.88102 8.38717 5.51369 10.0198C7.14636 11.6525 9.05369 12.6645 10.7957 12.9938C11.5024 13.1272 12.215 12.9212 12.709 12.4272L13.143 11.9932C13.6637 11.4725 13.6637 10.6285 13.143 10.1078L12.361 9.32584C11.9704 8.93517 11.337 8.93517 10.947 9.32584L10.345 9.9285C10.2004 10.0732 9.98102 10.1218 9.79369 10.0392C8.90769 9.64783 8.03369 9.05917 7.25369 8.27983Z",
    stroke: "#868C89",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgPhone;